import { NavigationProp } from '@react-navigation/native';
import React, {useState} from 'react';

import type { PropsWithChildren } from 'react';
import { View, Text, useWindowDimensions, ScrollView, Pressable, Linking, Platform } from 'react-native';
import HeaderComponent from '../components/headerComponent';
import {GlobalVariables} from '../utils/globalVariables';
import CardButtonComponent, { enumIconCardButtonComponent } from '../components/cardButtonComponent';
import { enumTypesButtonComponent } from '../components/buttonComponent';
import CreateResponsiveStyle from '../utils/responsiveStyle';
import { enumPages } from '../App';
import IconWhatsapp from '../source/icons/whatsapp';
import { SplashScreen } from '../utils/tranformClass';
import {useEffect} from 'react';

import ReadProperties from '../utils/comandos.js';
ReadProperties.leerArchivoProps();

import { StyleSheet, Button, Alert } from 'react-native';
const stylesamr = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
  },
});
const createTwoButtonAlert = () =>
Alert.alert('Alert Title', 'My Alert Msg', [
{
  text: 'Cancel',
  onPress: () => console.log('Cancel Pressed'),
  style: 'cancel',
},
{text: 'OK', onPress: () => console.log('OK Pressed')},
]);

type SectionProps = PropsWithChildren<{
  navigation: NavigationProp<any, any>;
}>;

function HomePage({ navigation }: SectionProps): JSX.Element {
	// +amr
	//amr const queryParams = new URLSearchParams(window.location.search);
	//amr var par = queryParams.get('lab');
	//amr var lab = par ? par : 'POLANCO';
	//amr ReadProperties.leerArchivoProps();
	var lab = GlobalVariables.vars.lab;
	var txt = GlobalVariables.vars.txt;
	var url = GlobalVariables.vars.url;
	var wur = GlobalVariables.vars.wur;
	//amr-1 var txt = 'Ir al sitio principal LMP';
	//amr-1 var url = 'https://lmpolanco.com/';
	//amr-1 var wur = 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0';
	//amr-1 var txt = 'Ir al sitio principal RUIZ';
	//amr-1 var url = 'https://laboratoriosruiz.com/';
	//amr-1 var wur = 'https://api.whatsapp.com/send?phone=5215580466180&text=Hola&type=phone_number&app_absent=0';
console.log('Cancel Pressed L[lab]-> ' + lab);
console.log('Cancel Pressed G[lab]-> ' + GlobalVariables.vars.lab);
console.log('Cancel Pressed G[api]-> ' + GlobalVariables.vars.api);
/* -amr
	if (lab.toUpperCase() === 'POLANCO') {
		//lab = lab.toUpperCase();
		txt = 'Ir al sitio principal LMP';
		url = 'https://lmpolanco.com/';
		wur = 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0';
		//amr-2 txt = 'Ir al sitio principal RUIZ';
		//amr-2 url = 'https://laboratoriosruiz.com/';
		//amr-2 wur = 'https://api.whatsapp.com/send?phone=5215580466180&text=Hola&type=phone_number&app_absent=0';
	} else {
		if (lab.toUpperCase() === 'RUIZ') {
			//lab = 'RUIZ'
			txt = 'Ir al sitio principal RUIZ';
			url = 'https://laboratoriosruiz.com/';
			wur = 'https://api.whatsapp.com/send?phone=5215580466180&text=Hola&type=phone_number&app_absent=0';
		} else {
			//lab = "POLANCO";
			txt = 'Ir al sitio principal LMP';
			url = 'https://lmpolanco.com/';
			wur = 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0';
			//amr-3 txt = 'Ir al sitio principal RUIZ';
			//amr-3 url = 'https://laboratoriosruiz.com/';
			//amr-3 wur = 'https://api.whatsapp.com/send?phone=5215580466180&text=Hola&type=phone_number&app_absent=0';
		}
	}
	// +amr
-amr */

  useEffect(()=>{
    setTimeout(() => {
      SplashScreen.hide();
    }, 3000);
  }, []);

  const layout = useWindowDimensions();
  const styles = responsiveStyle(layout);
  const stylesGeneral = GlobalVariables.class(layout);
  //Guarda el estado hover al pasar el cursor en ir a sitio principal de lmp
  const [hoverGoLMP, setHoverGoLMP] = useState(false);

  const navigateHomeBilling = () => {
    navigation.navigate(enumPages.facturacion);
    //amr navigation.navigate(enumPages.facturacion, {lab});
  };
  return (
    <View style={stylesGeneral('generalContainer')}>
      <ScrollView>
        <HeaderComponent navigation={navigation} />
        <View style={styles('container')}>
{/* -amr
<div>
   <h1>lab is {lab}</h1>
</div>
-amr */}
          <Text style={styles('title')}>Bienvenido(a)</Text>
          <Text style={styles('subtitle')}>Gracias por elegir nuestros servicios</Text>

<View style={stylesamr.container}>
	<Button title={'!! IMPORTANTE !!'} onPress={createTwoButtonAlert} />
	<Button title={'POR DISPOSICION DEL SAT, NO SE PUEDEN FACTURAR SERVICIOS DEL AÑO FISCAL ANTERIOR.'} onPress={createTwoButtonAlert} />
</View>

          <Text style={styles('resume')}>¡Esperamos que este portal de facturación sea una herramienta útil y valiosa para ti!</Text>
          <View style={styles('actions')}>
            <CardButtonComponent
              typeButton={enumTypesButtonComponent.primaryButton}
              icon={enumIconCardButtonComponent.facturacion}
              styleContent={styles('actionsLeft')}
              textButton="Generar mi factura"
              onPressCard={navigateHomeBilling}
              onPressButton={navigateHomeBilling}
            />
            {/* <CardButtonComponent
              disabledCard={true}
              icon={enumIconCardButtonComponent.fileResult}
              textButton='Consultar mis resultados'
              typeButton={enumTypesButtonComponent.secondaryButton} /> */}
          </View>
			<Text style={styles('resumida')}><h3>Para lograr una facturación exitosa tenga a la mano lo siguiente:</h3></Text>
			<Text style={styles('resumida')}><ul><li>Recibo de Compra</li><li>Constancia Fiscal&nbsp;&nbsp;</li><li>Uso del CFDI&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li></ul></Text>
          {
            Platform.OS === 'web' ?
              <Pressable
                style={{ marginTop: 80 }}
                onHoverIn={()=>setHoverGoLMP(true)}
                onHoverOut={()=>setHoverGoLMP(false)}
                onPress={()=>{
                  /* -amr let url = 'https://lmpolanco.com/' -amr */
                  window.location.href = url;
                }}>
                <Text style={[
                  stylesGeneral('primaryLink'),
                  hoverGoLMP && styles('hoverGoLMP'),
                ]}>{txt}</Text>
              </Pressable>
            : null
          }
        </View>
      </ScrollView>
      <Pressable style={stylesGeneral('iconWhatsapp')} onPress={()=>{
        /* -amr let url = GlobalVariables.vars.whatsappLink; -amr */
        url = wur;
        if (Platform.OS === 'web'){
          window.open(url, '_blank');
        } else {
          Linking.openURL(url);
        }
      }}>
        <IconWhatsapp />
      </Pressable>
    </View>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 80,
    paddingBottom: 40,
    paddingLeft: 15,
    paddingRight: 15,
  },
  title: {
    fontSize: 45,
    color: '#002395',
    fontWeight: '700',
    fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
    marginBottom: 20,
  },
  subtitle: {
    fontSize: 29,
    fontWeight: '700',
    color: GlobalVariables.colors.primary.darkGrey,
    marginBottom: 10,
    fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
  },
  resume: {
    fontSize: 16,
    color: GlobalVariables.colors.primary.darkGrey,
    fontWeight: '400',
    maxWidth: 500,
    textAlign: 'center',
    marginTop: 45,
    fontFamily: '"Helvetica Neue LT Std Roman", sans-serif',
  },
  resumida: {
    fontSize: 16,
    color: GlobalVariables.colors.primary.darkGrey,
    fontWeight: '400',
    maxWidth: 500,
    textAlign: 'center',
    marginTop: 1,
    fontFamily: '"Helvetica Neue LT Std Roman", sans-serif',
  },
  actions: {
    flexDirection: 'row',
    marginTop: 45,
    height: 200,
  },
  actionsLeft: {
    marginRight: 40,
  },
  hoverGoLMP:{
    color: GlobalVariables.colors.primary.orange,
  },
}, {
  container: {
    paddingTop: 50,
    paddingBottom: 40,
  },
  subtitle: {
    textAlign: 'center',
  },
  resume: {
    marginLeft: 35,
    marginRight: 35,
    marginTop: 20,
  },
  actions: {
    marginTop: 30,
    height: 'auto',
  },
  actionsLeft: {
    marginRight: 20,
  },
});
export default HomePage;
